<template>
  <div class="userset-bd">
    <div class="userset-aside">
      <h1>
        <i class="icon icon-yonghu information"></i>
        {{ $t('base_userset.ge_ren_xin_xi') }}
      </h1>
      <ul>
        <li :class="{ cur: currentTab === 'info' }"  @click="currentTab = 'info'">{{  $t('base_userset.zhang_hao_jian_jie') }}</li>
        <li :class="{ cur: currentTab === 'safe' }"  @click="currentTab = 'safe'">{{  $t('base_userset.zhang_hao_an_quan') }}</li>
        <li v-if="timeZoneIdList.length > 1" :class="{ cur: currentTab === 'date' }"  @click="currentTab = 'date'">{{ $t('base_userset.ri_qi_yu_shi_jian') }}</li>
        <li :class="{ cur: currentTab === 'msg' }"  @click="currentTab = 'msg'">{{  $t('base_userset.xiao_xi_she_zhi') }}</li>
        <li :class="{ cur: currentTab === 'bind' }"  @click="currentTab = 'bind'">{{  $t('base_userset.dsfbd') }}</li>
      </ul>
    </div>
    <div class="userset-section">
      <userset-info v-if="currentTab === 'info'"></userset-info>
      <userset-safe v-if="currentTab === 'safe'"></userset-safe>
      <userset-date v-if="currentTab === 'date'"></userset-date>
      <userset-msg v-if="currentTab === 'msg'"></userset-msg>
      <userset-bind v-if="currentTab === 'bind'"></userset-bind>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import usersetInfo from './children/userset_info';
import usersetSafe from './children/userset_safe';
import usersetDate from './children/userset_date';
import usersetBind from './children/userset_bind';
import usersetMsg from './children/userset_msg';

export default {
  name: 'userset',
  components: { usersetInfo, usersetSafe, usersetDate, usersetBind, usersetMsg },
  data() {
    return {
      currentTab: '',
      timeZoneIdList: [],
    };
  },
  mounted() {
    this.defaultTab();

    this.getTimeZoneIdList();
  },
  methods: {
    defaultTab: function () {
      const tab = this.getJump('tab') || 'info';
      this.currentTab = tab;
    },
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList, { orgId: this.orgId }).then((res) => {
        this.timeZoneIdList = res.data || [];
      });
    },
  }
};
</script>

<style lang="scss">
.userset-bd {
  height: 100%;
  position: relative;
  .userset-aside {
    position: absolute;
    width: 220px;
    background-color: #f9f9fd;
    top: 0;
    left: 0;
    bottom: 0;
    h1 {
      line-height: 70px;
      padding-left: 16px;
      font-size: 12px;
      color: #2c405e;
      font-weight: bold;
    }
    ul li {
      cursor: pointer;
      line-height: 50px;
      height: 50px;
      padding-left: 60px;
      font-size: 12px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      &.cur {
        font-weight: bold;
        background-color: #ffffff;
        color: #0d9ae0;
      }
    }
    .icon {
      font-size: 18px;
      color: #0d9ae0;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
  .userset-section {
    height: 100%;
    overflow-y: auto;
    padding-left: 220px;
    background-color: #ffffff;
  }
}
</style>
